module.exports = __webpack_public_path__ + "static/media/envio.a7e16c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/eshopex/envio.png
// module id = 1210
// module chunks = 0